'use-strict'
export const SELECT_ITEM = 'SELECT_ITEM'
export const TOGGLE_ALL = 'TOGGLE_ALL'
export const TOGGLE_ITEM = 'TOGGLE_ITEM'
export const TOGGLE_UNIT = 'TOGGLE_UNIT'
export const TOGGLE_SHIFT_UNIT = 'TOGGLE_SHIFT_UNIT'
export const TOGGLE_ALL_UNITS = 'TOGGLE_ALL_UNITS'
export const SELECT_UNIT = 'SELECT_UNIT'
export const ADD_DROP_UNITS = 'ADD_DROP_UNITS'
export const ADD_DROP_UNIT = 'ADD_DROP_UNIT'
export const CHANGE_UNIT_PARENT_ID = 'CHANGE_UNIT_PARENT_ID'
export const REMOVE_UNIT = 'REMOVE_UNIT'
export const SELECT_DROP_DETAILS_VIEW = 'SELECT_DROP_DETAILS_VIEW'
export const SELECT_DROP_DETAILS_VIEW_UNITS = 'SELECT_DROP_DETAILS_VIEW_UNITS'
export const CHANGE_ACTUAL_PAGE = 'CHANGE_ACTUAL_PAGE'
export const UPDATE_ITEM = 'UPDATE_ITEM'
export const HOVERED_UNIT = 'HOVERED_UNIT'
export const SORT_DETAIL_UNITS = 'SORT_DETAIL_UNITS'
export const FILTER_ORDER_REF_DETAIL_UNITS = 'FILTER_ORDER_REF_DETAIL_UNITS'
export const FILTER_CUSTOMER_REF_DETAIL_UNITS = 'FILTER_CUSTOMER_REF_DETAIL_UNITS'
export const FILTER_ITEM_CATEGORY_DETAIL_UNITS = 'FILTER_ITEM_CATEGORY_DETAIL_UNITS'
export const LOADING_NEW_DROPS = 'LOADING_NEW_DROPS'
export const TOGGLE_DROP_ORDER = 'TOGGLE_DROP_ORDER'
export const SET_CUSTOM_NAME = 'SET_CUSTOM_NAME'
export const SET_CUSTOM_WEIGHT = 'SET_CUSTOM_WEIGHT'
export const SET_CUSTOM_DIMENSIONS = 'SET_CUSTOM_DIMENSIONS'
export const SET_CUSTOM_STATUS = 'SET_CUSTOM_STATUS'
export const ADD_NEW_UNIT_PARENT_ID = 'ADD_NEW_UNIT_PARENT_ID'
export const UPDATE_DROP_VOLUME_WEIGHT_ADD = 'UPDATE_DROP_VOLUME_WEIGHT_ADD'
export const UPDATE_DROP_VOLUME_WEIGHT_REMOVE = 'UPDATE_DROP_VOLUME_WEIGHT_REMOVE'
export const UPDATE_DROP_UNIT_TYPE_COUNT = 'UPDATE_DROP_UNIT_TYPE_COUNT'
export const SET_PALLET_CALCULATION_WARNINGS = 'SET_PALLET_CALCULATION_WARNINGS'
export const SET_UNIT_CUSTOMER_REF_NUMBER = 'SET_UNIT_CUSTOMER_REF_NUMBER'
export const SET_SELECTED_DROP_ORIGIN_LOCATION = 'SET_SELECTED_DROP_ORIGIN_LOCATION'
export const SET_SELECTED_DROP_DESTINATION_LOCATION = 'SET_SELECTED_DROP_DESTINATION_LOCATION'
export const SET_AVAILABLE_PALLETS = 'SET_AVAILABLE_PALLETS'
